import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function TrustBadge() {
  return <div className="bg-white py-10 border-y border-zinc-200" data-id="element-234">
      <div className="max-w-4xl mx-auto px-4 flex flex-col items-center gap-6" data-id="element-235">
        <p className="text-zinc-500 text-xs font-bold uppercase tracking-widest" data-id="element-236">
          Pago 100% Seguro Procesado Por
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/fvwVbGdXPWwQ3QsSQDAFV9/pasted-image.png" alt="Mercado Pago" className="h-12 md:h-16 w-auto object-contain" data-id="element-237" />
        <div className="flex flex-wrap justify-center items-center gap-6 text-zinc-400 text-xs font-medium" data-id="element-238">
          <span className="flex items-center gap-1.5" data-id="element-239">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-240" />
            Transacción Encriptada SSL
          </span>
          <span className="flex items-center gap-1.5" data-id="element-241">
            <Lock className="w-4 h-4 text-green-500" data-id="element-242" />
            Datos 100% Protegidos
          </span>
        </div>
      </div>
    </div>;
}